<template>
  <div>
    <custom-actions show-back :title="title">
      <el-form class="form" :model="formData" :rules="rules" ref="formData" label-width="140px">
        <!-- 充值 -->
        <template v-if="depositType === '1'">
          <el-form-item label="付款方" prop="payer">
            <el-select filterable clearable v-model="formData.payer" placeholder="请选择付款方">
              <el-option v-for="(item, index) of userList1" :value="item.userId" :label="item.userName"
                :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="供应商名称" prop="userId">
            <el-select filterable clearable v-model="formData.userId" @change="supplierChange" placeholder="请选择供应商名称">
              <el-option v-for="(item, index) of userList" :value="item.userId" :label="item.userName"
                :key="index"></el-option>
            </el-select>
          </el-form-item>
        </template>
        <!-- 退还 -->
        <template v-if="depositType === '2'">
          <el-form-item label="收款方" prop="payer">
            <el-select filterable clearable v-model="formData.payer" placeholder="请选择收款方">
              <el-option v-for="(item, index) of userList1" :value="item.userId" :label="item.userName"
                :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="退款方" prop="userId">
            <el-select filterable clearable v-model="formData.userId" @change="supplierChange" placeholder="请选择供退款方">
              <el-option v-for="(item, index) of userList" :value="item.userId" :label="item.userName"
                :key="index"></el-option>
            </el-select>
          </el-form-item>
        </template>
        <!-- 转换 -->
        <template v-if="depositType === '3'">
          <el-form-item label="采购方" prop="payer">
            <el-select filterable clearable v-model="formData.payer" placeholder="请选择采购方">
              <el-option v-for="(item, index) of userList1" :value="item.userId" :label="item.userName"
                :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="供应商名称" prop="userId">
            <el-select filterable clearable v-model="formData.userId" @change="supplierChange" placeholder="请选择供应商名称">
              <el-option v-for="(item, index) of userList" :value="item.userId" :label="item.userName"
                :key="index"></el-option>
            </el-select>
          </el-form-item>
        </template>

        <!-- 充值 -->
        <template v-if="depositType === '1'">
          <el-form-item label="合同号" prop="contractNumber">
            <el-input v-model.trim="formData.contractNumber" maxlength="100" placeholder="请输入合同号"></el-input>
          </el-form-item>
          <el-form-item label="充值金额" prop="depositChange">
            <el-input v-model="formData.depositChange" placeholder="请输入充值金额"></el-input>
          </el-form-item>
        </template>

        <!-- 退还 -->
        <template v-if="depositType === '2'">
          <el-form-item prop="depositNumber" label="付款凭证单号">
            <el-input v-model="formData.depositNumber" placeholder="请输入付款凭证单号"></el-input>
          </el-form-item>
          <el-form-item prop="fkBank" label="收款银行">
            <el-input v-model="formData.fkBank" placeholder="请输入收款银行"></el-input>
          </el-form-item>
          <el-form-item label="退还金额" prop="depositChange">
            <el-input v-model="formData.depositChange" :placeholder="'最大可退金额' + depositChangeMax"></el-input>
          </el-form-item>
          <el-form-item prop="transferDate" label="日期">
            <el-date-picker v-model="formData.transferDate" type="date" value-format="yyyy-MM-dd"
                            placeholder="请选择日期"></el-date-picker>
          </el-form-item>

          <el-form-item label="付款银行" prop="receivingBank">
            <el-input v-model="formData.receivingBank" placeholder="请输入付款银行"></el-input>
          </el-form-item>
          <el-form-item label="付款账号" prop="receivingAccount">
            <el-input v-model="formData.receivingAccount" placeholder="请输入付款账号"></el-input>
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item label="收款银行">
            <el-input v-model="formData.receivingBank" placeholder="请输入收款银行"></el-input>
          </el-form-item>
          <el-form-item label="收款账号">
            <el-input v-model="formData.receivingAccount" placeholder="请输入收款账号"></el-input>
          </el-form-item>
        </template>

        <!-- 转换 -->
        <template v-if="depositType === '3'">
          <el-form-item label="转换金额" prop="depositChange">
            <el-input v-model="formData.depositChange" :placeholder="'最大可转金额' + depositChangeMax"></el-input>
          </el-form-item>
        </template>

        <!-- <el-form-item label="流水凭证单号" prop="depositNumber">
          <el-input v-model="formData.depositNumber" placeholder="请输入流水凭证单号"></el-input>
        </el-form-item> -->

        <!-- <el-form-item label="充值/退还/转换" prop="depositType">
          <el-select v-model="formData.depositType" filterable>
            <el-option :value="item.value" :label="item.label" v-for="(item, index) of depositTypeList"
              :key="index"></el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="金额类型" prop="transactionType">
          <el-radio-group v-model="formData.transactionType">
            <el-radio :label="item.value" v-for="(item, index) of transactionTypeList" :key="index">{{ item.label
            }}</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <!-- <el-form-item label="转账日期" prop="transferDate">
          <el-date-picker v-model="formData.transferDate" type="date" placeholder="请选择转账日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="收款银行" prop="receivingBank">
          <el-input v-model="formData.receivingBank" placeholder="请输入收款银行"></el-input>
        </el-form-item>
        <el-form-item label="收款账号" prop="receivingAccount">
          <el-input v-model="formData.receivingAccount" placeholder="请输入收款账号"></el-input>
        </el-form-item> -->
        <el-form-item v-if="depositType === '1'" label="备注" prop="remark">
          <el-input v-model="formData.remark" type="textarea" :rows="3" maxlength="1000"
            show-word-limit placeholder="请输入备注（选填）"></el-input>
        </el-form-item>

        <el-form-item label="附件" prop="fileList">
          <file-upload v-model="formData.fileList"></file-upload>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submit" class="global-button">保存</el-button>
          <!-- <el-button type="primary" @click="dialogVisible = true" class="global-button">审批</el-button> -->
          <el-button @click="$router.back()" class="global-button">取消</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

  </div>
</template>

<script>
import { depositType, ycTransactionType } from '@/utils/dict'
import { mapToObjectArray } from '@/utils/utils'
export default {
  components: {
  },
  name: 'BondRecordAdd3',
  data() {
    return {
      skyhList: [],
      dialogVisible: false,
      transactionTypeList: mapToObjectArray(ycTransactionType),
      depositTypeList: mapToObjectArray(depositType),
      formData: {
        depositNumber: '', // 订单编号
        contractNumber: '', // 合同号（选填）
        remark: '', // 付款备注
        isJr: '2',
        payer: '', // 付款方
        userId: '', // 关联客户ID，关联客户表
        depositStatus: '', // 工单状态，1审批中2审批通过3作废
        approvalStatus: '', // 审批状态，1待审批，2审批通过，3审批驳回
        depositType: '', // 类型1充值2退还3保证金转货款
        depositChange: '', // 充值/退还金额
        transactionType: '', // 金额类型 1 保证金 2 货款
        transferDate: '', // 转账日期
        receivingBank: '', // 收款银行
        receivingAccount: '', // 收款账号
        fileList: [] // 附件列表
      },
      rules: {
        depositNumber: [{ required: true, message: '请输入付款凭证单号', trigger: ['change', 'blur'] }],
        depositType: [{ required: true, message: '请选择类型', trigger: 'change' }],
        depositChange: [
          { required: true, message: '请输入金额', trigger: ['change', 'blur'] },
          {
            validator: (rule, value, callback) => {
              console.log('value', value)
              console.log('typeof', typeof value)
              if (parseFloat(value) <= 1) {
                callback(new Error('金额不能小于1'))
              } else {
                callback()
              }
            },
            trigger: ['change', 'blur']
          }
        ],
        transactionType: [{ required: true, message: '请选择金额类型', trigger: 'change' }],
        fkBank: [{ required: true, message: this.depositType === '2' ? '请输入付款银行' : '请输入收款银行', trigger: 'change' }],
        transferDate: [{ required: true, message: '请选择日期', trigger: 'change' }],
        receivingBank: [{ required: true, message: this.depositType === '2' ? '请输入收款银行' : '请输入付款银行', trigger: 'change' }],
        receivingAccount: [{ required: true, message: this.depositType === '2' ? '请输入收款账号' : '请输入付款账号', trigger: 'change' }],
        fileList: [{ required: false, message: '请上传附件', trigger: ['change', 'blur'] }],
        userId: [{ required: true, message: '请选择供应商名称', trigger: 'change' }],
        payer: [{ required: true, message: '请选择付款方', trigger: 'change' }]
      },
      userFundInfo: {
        userId: '',
        userName: '',
        depositAllChange: '',
        depositChange: '',
        depositAfterChange: '',
        goodsChange: '',
        goodsAfterChange: ''
      },
      userList: [],
      userList1: []
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.user
    },
    depositId() {
      return this.$route.query.depositId
    },
    depositType() {
      return this.$route.query.depositType
    },
    transactionType() {
      return this.$route.query.transactionType
    },
    depositChangeMax() {
      if (['2', '3'].includes(this.depositType)) {
        if (this.transactionType === '1') {
          return this.userFundInfo.depositAfterChange
        } else if (this.transactionType === '2') {
          return this.userFundInfo.goodsAfterChange
        }
      }
      return ''
    },
    title() {
      const typeChange = ['转货款', '转保证金']
      const name = ycTransactionType.get(this.transactionType) || ''
      let type = depositType.get(this.depositType) || ''
      if (this.depositType === '3') {
        type = typeChange[Number(this.transactionType) - 1]
      }
      return '新增' + name + type
    }
  },
  created() {
    this.loadUserList()
    this.loadUser1()
    this.loadDict()
    if (this.depositId) {
      this.loadDetails()
    } else {
      this.formData.depositType = this.depositType
      this.formData.transactionType = this.transactionType
    }
  },
  methods: {
    supplierChange(userId) {
      const supplier = this.userList.find((item) => item.userId === userId)
      if (supplier) {
        this.formData.receivingBank = supplier.bankName || ''
        this.formData.receivingAccount = supplier.bankAccount || ''
      }
      this.loadUserFundInfo(userId)
    },
    loadUserFundInfo(userId) {
      if (this.depositType !== '1') {
        this.$axios.get(this.$apis.yxcUserBond.selectYxcUserDepositByDepositId, {
          params: { userId: userId }
        }).then(res => {
          this.userFundInfo = Array.isArray(res.list) ? (res.list[0] || {}) : res
        })
      }
    },
    loadDict() {
      this.$axios.get(this.$apis.common.selectDicByList, {
        params: { dicType: 'skyh' }
      }).then(res => {
        this.skyhList = res.skyh
      })
    },
    loadUserList() {
      this.$axios.get(this.$apis.patrolProblemReport.selectIparkUserByRole, {
        userType: '4'
      }).then(res => {
        this.userList = res || []
      })
    },
    loadUser1() {
      this.$axios.get(this.$apis.system.selectSysUserByList, {
        userType: '2,3',
        yxcQx: '1'
      }).then(res => {
        this.userList1 = res || []
      })
    },
    loadDetails() {

    },
    submit() {
      this.$refs.formData.validate().then(() => {
        const url = this.$apis.yxcBondRecord.insertYxcUserDepositNew
        this.$axios.post(url, this.formData).then(res => {
          this.$router.back()
        })
      })
    }

  }
}
</script>

<style scoped lang='scss'>
.del-btn {
  color: red;
}

.el-select,
.el-input,
.el-textarea,
.el-cascader {
  width: 400px;
}
</style>
